import MerakiLogo from "../../images/test1.png";
import AarkayLogo from "../../images/vrujen.jpeg";
import ArkZephyrLogo from "../../images/arkZephyr.png";

export const TestimonialObjOne = {
  reviewDesc:
    "Kartik is very dedicated to his work. He is always ready to try out new things and incorporate new features that we were looking for. He would always go out of his way to work and learn new things. A very sincere and hard-working person.",
  reviewAuthor: "DISHA SAIGAL",
  reviewAuthorTitle: "Meraki Art Gallery",
  reviewAuthorImage: MerakiLogo,
};

export const TestimonialObjTwo = {
  reviewDesc:
    "Kartik is a very ambitious hard working professional. He has achieved every target he sets and is growing every day with newer, more advanced skills. I would totally recommend this professional for ANY kind of project. He will surely give it his 110!",
  reviewAuthor: "VRUJEN ANDHARE",
  reviewAuthorTitle: "Director, Aarkay Techno consultants Pvt. Ltd.",
  reviewAuthorImage: AarkayLogo,
};

export const TestimonialObjThree = {
  reviewDesc:
    "Kartik is easy to work with and has a quick turn around time. He's able to work with teams and incorporate their visualisations in the website. He's got a good attitude of not saying no and is not shy of going back to research.",
  reviewAuthor: "ADITI DALMIA",
  reviewAuthorTitle: "Meraki Art Gallery",
  reviewAuthorImage: MerakiLogo,
};

export const TestimonialObjFour = {
  reviewDesc:
    "We have had a fantastic experience working with Kartik to create our website on a platform he was also new to and experimenting with. But, his commitment and enthusiasm to the project were what set him apart.",
  reviewAuthor: "Shivani Dewan",
  reviewAuthorTitle: "Meraki Art Gallery",
  reviewAuthorImage: MerakiLogo,
};

export const TestimonialObjFive = {
  reviewDesc:
    "Kartik knows his strengths really well. He is always trying to get better at the things he is passionate about! He is a wonderful person to work with and with his out of the box way of thinking and sometimes even some of his crazy ideas can turn up to be gamechangers!",
  reviewAuthor: "Terrance James",
  reviewAuthorTitle: "Zephyris",
  reviewAuthorImage: ArkZephyrLogo,
};

export const TestimonialObjSix = {
  reviewDesc:
    "A person of resolute routine and discipline. Friendly, easy to converse with, always motivates others to be their best selves and achieve more. Would recommend this professional if you want quality outcomes!",
  reviewAuthor: "Vishwanath Sharma",
  reviewAuthorTitle: "Education Specialist, Educational Initiatives",
  reviewAuthorImage: ArkZephyrLogo,
};
